module.exports = __webpack_public_path__ + "static/media/junatara_end.32f968b2.png";